import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
} from "reactstrap";

function PartsAvailability() {
  return (
    <Container fluid className="mt-4">
      <Row>
        <Col className="mb-5" md="12">
          <Card>
            <CardHeader className="d-flex align-items-center justify-content-between mb-2">
              <CardTitle tag="h3" className="font-weight-normal">
                Parts Availability
              </CardTitle>
            </CardHeader>
            <CardBody className="pt-2">
              <div>Module yet to be discussed</div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default PartsAvailability;
